import React, { useState, useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { EffectCoverflow, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/navigation'
import styles from './TeamsSlider.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'

const TeamSlider = () => {
	const swiperRef = useRef(null)
	const [isTouchDevice, setIsTouchDevice] = useState(false)
	const [teamMembers, setTeamMembers] = useState([])
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)
	const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';
	useEffect(() => {
		setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0)
	}, [])

	useEffect(() => {
		fetch(`${API_PREFIX}/api/sections/get/team/list`)
			.then((res) => {
				if (!res.ok) throw new Error('Ошибка загрузки команды')
				return res.json()
			})
			.then((data) => {
				setTeamMembers(data.teamMembers ?? [])
				setLoading(false)
			})
			.catch((e) => {
				setError(e.message)
				setLoading(false)
			})
	}, [])

	const handleButtonEffect = (e) => {
		if (!e.currentTarget) return
		e.currentTarget.classList.add('active')
		setTimeout(() => {
			if (e.currentTarget) {
				e.currentTarget.classList.remove('active')
			}
		}, 300)
	}

	return (
		<section className={styles.teamSlider} id='teachers'>
			<SectionTitle>Наша команда преподавателей</SectionTitle>

			{loading && <div>Загрузка...</div>}
			{error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}

			{!loading && !error && (
				<>
					<Swiper
						ref={swiperRef}
						effect={'coverflow'}
						grabCursor={true}
						centeredSlides={true}
						slidesPerView={'auto'}
						loop={true}
						initialSlide={2}
						coverflowEffect={{
							rotate: 20,
							stretch: -30,
							depth: 150,
							modifier: 2,
							slideShadows: false,
						}}
						navigation={{
							nextEl: `.${styles.buttonNext}`,
							prevEl: `.${styles.buttonPrev}`,
						}}
						modules={[EffectCoverflow, Navigation]}
						className={styles.teamSliderSwiper}
					>
						{teamMembers.map((member) => (
							<SwiperSlide key={member.id} className={styles.slide}>
								<div className={styles.imageWrapper}>
									<img
										src={member.image}
										alt={member.name}
										className={styles.image}
									/>
								</div>
								<div className={styles.content}>
									<h3 className={styles.name}>{member.name}</h3>
									<p className={styles.education}>{member.education}</p>
									<p className={styles.experience}>
										<strong>Опыт работы</strong> – {member.experience}
									</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>

					{/* Кастомные кнопки навигации */}
					<div className={styles.navigation}>
						<div
							className={styles.buttonPrev}
							onClick={() => swiperRef.current?.swiper.slidePrev()}
						>
							<div
								className={styles.btnContainer}
								{...(isTouchDevice
									? { onTouchStart: handleButtonEffect }
									: { onMouseDown: handleButtonEffect })}
							>
								<div className={styles.consultBtn}>
									<img src='/img/slider/arrow-left.svg' alt='Предыдущий' />
								</div>
							</div>
						</div>

						<div
							className={styles.buttonNext}
							onClick={() => swiperRef.current?.swiper.slideNext()}
						>
							<div
								className={styles.btnContainer}
								{...(isTouchDevice
									? { onTouchStart: handleButtonEffect }
									: { onMouseDown: handleButtonEffect })}
							>
								<div className={styles.consultBtn}>
									<img src='/img/slider/arrow-right.svg' alt='Следующий' />
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</section>
	)
}

export default TeamSlider
